export default __webpack_public_path__ + "static/media/bg-curvy-mobile.3ab5d2c7.svg";